import type { PropsWithChildren } from "react";

import { StyledFlex } from "./PlaygroundSubSectionLayout.styled";

import type { PlaygroundSubSectionLayoutProps } from ".";

export function PlaygroundSubSectionLayout({
  children,
  ...props
}: PropsWithChildren<PlaygroundSubSectionLayoutProps>) {
  return (
    <StyledFlex gap="xxs" flexDirection="column" {...props}>
      {children}
    </StyledFlex>
  );
}
